import { tns } from 'tiny-slider';

export function merkenSlider() {
    let slider = document.getElementById('deelnemende-centra-slider');
    if (slider) {
        slider = tns({
            container: '#deelnemende-centra-slider',
            items: 2,
            gutter: 16,
            autoplay: true,
            autoplaySpeed: 500,
            autoplayTimeout: 5000,
            autoplayButton: false,
            autoplayButtonOutput: '',
            controls: false,
            controlsPosition: 'bottom',
            controlsText: ['<span class="icon-basic icon-chevron-left-circled"></span>', '<span class="icon-basic icon-chevron-right-circled"></span>'],
            nav: true,
            mouseDrag: true,
            //autoplayHoverPause: true, //too buggy right now, but should be added.
            touch: true,
            responsive: {
                460: {
                    items: 3
                },
                576: {
                    items: 4,
                    gutter: 32,
                },
                768: {
                    items: 5,
                    gutter: 64,
                }
            }
        });
    }
    return 'merkenSlider';
}

export function artikelenSlider() {
    let slider = document.getElementById('artikelen-slider');
    if (slider) {
        slider = tns({
            container: '#artikelen-slider',
            items: 1.25,
            gutter: 16,
            autoplay: false,
            autoplaySpeed: 500,
            autoplayTimeout: 8000,
            autoplayButton: false,
            autoplayButtonOutput: '',
            controls: false,
            controlsPosition: 'bottom',
            controlsText: ['<span class="icon-basic icon-chevron-left-circled"></span>', '<span class="icon-basic icon-chevron-right-circled"></span>'],
            nav: true,
            mouseDrag: true,
            //autoplayHoverPause: true, //too buggy right now, but should be added.
            touch: true,
            responsive: {
                460: {
                    items: 1.5,
                    gutter: 24,
                },
                576: {
                    items: 2
                },
                1024: {
                    items: 2.5
                },
                1366: {
                    items: 3
                }
            }
        });
    }
    return 'artikelenSlider';
}





export function trajectSlider() {
    let slider = document.getElementById('traject-slider');
    if (slider) {
        slider = tns({
            container: '#traject-slider',
            items: 1,
            gutter: 24,
            center: true,
            autoplay: false,
            //autoHeight: true,
            autoplaySpeed: 500,
            autoplayTimeout: 8000,
            autoplayButton: false,
            autoplayButtonOutput: '',
            controls: false,
            controlsPosition: 'top',
            controlsText: ['<span class="icon-basic icon-chevron-left-circled"></span>', '<span class="icon-basic icon-chevron-right-circled"></span>'],
            nav: true,
            navPosition: 'top',
            mouseDrag: true,
            navAsThumbnails: true,
            //autoplayHoverPause: true, //too buggy right now, but should be added.
            touch: true,
            responsive: {
                768: {
                    items: 2,
                    autoHeight: false
                }
            }
        });

        let wrapper = document.querySelector('.traject__slider')

        const dots = wrapper.querySelectorAll('.tns-nav button');

        dots.forEach(function (dot, i) {
            dot.innerHTML = (i + 1);
        });


    }
    return 'trajectSlider';
}
